var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PCNavbar',{attrs:{"selectIndex":"5"}}),_c('MobileNavBar'),_c('DemoForm'),_c('CallMe')],1)}
var staticRenderFns = []

export { render, staticRenderFns }